(function(app) {

    app.provider(
        "transactionFundingSourceApi", [function() {
            this.$get = [
                "complianceHubApiGateway", function(complianceHubApiGateway) {
                    var service = {};

                    service.get = function(transactionId, transactionFundingSourceId) {
                        return complianceHubApiGateway.get("/Transactions/" +
                            transactionId +
                            "/FundingSources/" +
                            transactionFundingSourceId);
                    };

                    service.getFundingSourcesForTransaction = function(transactionId) {
                        return complianceHubApiGateway.getArray("/Transactions/" + transactionId + "/FundingSources");
                    };

                    service.update = function(source) {
                        return complianceHubApiGateway.put("/Transactions/" +
                            source.TransactionId +
                            "/FundingSources/" +
                            source.Id,
                            source);
                    };

                    service.add = function(source) {
                        return complianceHubApiGateway.post("/Transactions/" + source.TransactionId + "/FundingSources",
                            source);
                    };

                    service.remove = function(transactionId, transactionFundingSourceId) {
                        return complianceHubApiGateway
                            .delete("/Transactions/" + transactionId + "/FundingSources/" + transactionFundingSourceId);
                    }

                    return service;
                }
            ];
        }
    ]);
})(window.app); //jshint ignore:line